/**
 * icon by Michael Irigoyen @mririgo
 * https://materialdesignicons.com/icon/folder-zip
 */

import React from 'react'

const ZipFileIcon = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={fill}
        d="M18 2H10L8 0H2C0.9 0 0 0.9 0 2V14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V4C20 2.9 19.1 2 18 2ZM16 8H14V10H16V12H14V14H12V12H14V10H12V8H14V6H12V4H14V6H16V8Z"
      />
    </svg>
  )
}

export default ZipFileIcon
